export default "__VITE_ASSET__2714b24c__"